import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ManagementLeadershipPage = lazy(() => import('../pages/management-leadership/page'));
const StrategieOperationnellePage = lazy(() => import('../pages/strategie-operationnelle/page'));
const SuiviProductivitePage = lazy(() => import('../pages/suivi-productivite/page'));
const RHDeveloppementPage = lazy(() => import('../pages/rh-developpement/page'));
const QuiSommesNousPage = lazy(() => import('../pages/qui-sommes-nous/page'));
const NosValeursPage = lazy(() => import('../pages/nos-valeurs/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const ConfidentialitePage = lazy(() => import('../pages/confidentialite/page'));
const CoachingDirigeantPage = lazy(() => import('../pages/management-leadership/coaching-dirigeant/page'));
const CoachingManagersPage = lazy(() => import('../pages/management-leadership/coaching-managers/page'));
const Assessment360Page = lazy(() => import('../pages/management-leadership/assessment-360/page'));
const IntelligenceEmotionnellePage = lazy(() => import('../pages/management-leadership/intelligence-emotionnelle/page'));
const GestionConflitsPage = lazy(() => import('../pages/management-leadership/gestion-conflits/page'));
const PerformanceCollectivePage = lazy(() => import('../pages/management-leadership/performance-collective/page'));
const ManagementIntergenerationnelPage = lazy(() => import('../pages/management-leadership/management-intergenerationnel/page'));
const DiagnosticStrategiquePage = lazy(() => import('../pages/strategie-operationnelle/diagnostic-strategique/page'));
const PlanStrategiquePage = lazy(() => import('../pages/strategie-operationnelle/plan-strategique/page'));
const OptimisationProcessusPage = lazy(() => import('../pages/strategie-operationnelle/optimisation-processus/page'));
const PilotageProjetPage = lazy(() => import('../pages/strategie-operationnelle/pilotage-projets/page'));
const OKRDeploymentPage = lazy(() => import('../pages/strategie-operationnelle/okr-deployment/page'));
const BusinessPlanPage = lazy(() => import('../pages/suivi-productivite/business-plan/page'));
const GoToMarketPage = lazy(() => import('../pages/suivi-productivite/go-to-market/page'));
const DashboardKpisPage = lazy(() => import('../pages/suivi-productivite/dashboard-kpis/page'));
const AnalyseRoiPage = lazy(() => import('../pages/suivi-productivite/analyse-roi/page'));
const DataAnalyseRHPage = lazy(() => import('../pages/rh-developpement/data-analyse-rh/page'));
const AnalysesHumainesPage = lazy(() => import('../pages/rh-developpement/analyses-humaines/page'));
const ArticlesPage = lazy(() => import('../pages/articles/page'));
const ArticleDetailPage = lazy(() => import('../pages/articles/article-detail/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/management-leadership',
    element: <ManagementLeadershipPage />,
  },
  {
    path: '/management-leadership/coaching-dirigeant',
    element: <CoachingDirigeantPage />,
  },
  {
    path: '/management-leadership/coaching-managers',
    element: <CoachingManagersPage />,
  },
  {
    path: '/management-leadership/assessment-360',
    element: <Assessment360Page />,
  },
  {
    path: '/management-leadership/intelligence-emotionnelle',
    element: <IntelligenceEmotionnellePage />,
  },
  {
    path: '/management-leadership/gestion-conflits',
    element: <GestionConflitsPage />,
  },
  {
    path: '/management-leadership/performance-collective',
    element: <PerformanceCollectivePage />,
  },
  {
    path: '/management-leadership/management-intergenerationnel',
    element: <ManagementIntergenerationnelPage />,
  },
  {
    path: '/strategie-operationnelle',
    element: <StrategieOperationnellePage />,
  },
  {
    path: '/strategie-operationnelle/diagnostic-strategique',
    element: <DiagnosticStrategiquePage />,
  },
  {
    path: '/strategie-operationnelle/plan-strategique',
    element: <PlanStrategiquePage />,
  },
  {
    path: '/strategie-operationnelle/optimisation-processus',
    element: <OptimisationProcessusPage />,
  },
  {
    path: '/strategie-operationnelle/pilotage-projets',
    element: <PilotageProjetPage />,
  },
  {
    path: '/strategie-operationnelle/okr-deployment',
    element: <OKRDeploymentPage />,
  },
  {
    path: '/suivi-productivite',
    element: <SuiviProductivitePage />,
  },
  {
    path: '/suivi-productivite/business-plan',
    element: <BusinessPlanPage />,
  },
  {
    path: '/suivi-productivite/go-to-market',
    element: <GoToMarketPage />,
  },
  {
    path: '/suivi-productivite/dashboard-kpis',
    element: <DashboardKpisPage />,
  },
  {
    path: '/suivi-productivite/analyse-roi',
    element: <AnalyseRoiPage />,
  },
  {
    path: '/rh-developpement',
    element: <RHDeveloppementPage />,
  },
  {
    path: '/rh-developpement/data-analyse-rh',
    element: <DataAnalyseRHPage />,
  },
  {
    path: '/rh-developpement/analyses-humaines',
    element: <AnalysesHumainesPage />,
  },
  {
    path: '/qui-sommes-nous',
    element: <QuiSommesNousPage />,
  },
  {
    path: '/nos-valeurs',
    element: <NosValeursPage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/confidentialite',
    element: <ConfidentialitePage />,
  },
  {
    path: '/articles',
    element: <ArticlesPage />,
  },
  {
    path: '/articles/:id',
    element: <ArticleDetailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
